import { createEntityAdapter, EntityState } from '@reduxjs/toolkit';

import { CensusBadgeDto, FacilityQuickNotesDto, UnacknowledgedQuickNotesBadgeDto, UnsignedStatsDto } from '@medone/medonehp-api-client';

import { PrintState } from './unsigned-notes/print';

export const quickNotesBadgesAdapter = createEntityAdapter<CensusBadgeDto, number>({
    selectId: (item) => item.patientIntakeId,
});

export interface PostAcuteState {
    isReady: boolean;
    errorMessage: string | null;
    totalUnsignedNotes: UnsignedStatsDto;
    totalUnacknowledgedQuickNotes: UnacknowledgedQuickNotesBadgeDto;
    totalDraftQuickNotes: number;
    unacknowledgedQuickNotes: FacilityQuickNotesDto[];
    totalReturnToHospital: number;
    /** null = unknown (not permitted, flag off, or vendor failure): badge renders nothing (SCRUM-805). */
    totalPendingErxMessages: number | null;
    quickNotesBadges: EntityState<CensusBadgeDto, number>;
    printState: PrintState;
}

export const initialState: PostAcuteState = {
    isReady: false,
    errorMessage: null,
    totalUnsignedNotes: null,
    totalUnacknowledgedQuickNotes: null,
    totalDraftQuickNotes: null,
    unacknowledgedQuickNotes: [],
    totalReturnToHospital: null,
    totalPendingErxMessages: null,
    quickNotesBadges: quickNotesBadgesAdapter.getInitialState({}),
    printState: null,
};

export interface FacilityQuickNotesCountUpdatedDto {
    admittedToId: number;
    quickNotesNeedsFollowupCount: number;
    quickNotesUnacknowledgedCount: number;
}

export interface ProviderQuickNotesCountUpdatedDto {
    adSid: string;
    drafts: UnacknowledgedQuickNotesBadgeDto;
    nonDrafts: UnacknowledgedQuickNotesBadgeDto;
}
